import React from "react";
import PropTypes from "prop-types";
import { Box, Button } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import HistoryIcon from "@mui/icons-material/History";

const BondArchivesToolbar = ({
  handleOpenBypassHistory,
  canOverridePaymentStatus,
  handleOpenPaymentOverrideHistory,
  handleExport,
  handleRefreshClick,
  loading,
  setFilterDialogOpen,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mb: 2 }}>
      <Button onClick={handleOpenBypassHistory} startIcon={<HistoryIcon />}>
        View API Bypass History
      </Button>
      {canOverridePaymentStatus ? (
        <Button onClick={handleOpenPaymentOverrideHistory} startIcon={<HistoryIcon />}>
          Payment Override History
        </Button>
      ) : null}
      <Button onClick={handleExport} startIcon={<DownloadIcon />}>
        Export
      </Button>
      <Button
        onClick={handleRefreshClick}
        startIcon={<RefreshIcon />}
        disabled={loading}
      >
        {loading ? "Refreshing..." : "Refresh"}
      </Button>
      <Button
        variant="contained"
        onClick={() => setFilterDialogOpen(true)}
        startIcon={<FilterListIcon />}
      >
        Filters
      </Button>
    </Box>
  );
};

BondArchivesToolbar.propTypes = {
  handleOpenBypassHistory: PropTypes.func.isRequired,
  canOverridePaymentStatus: PropTypes.bool.isRequired,
  handleOpenPaymentOverrideHistory: PropTypes.func.isRequired,
  handleExport: PropTypes.func.isRequired,
  handleRefreshClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setFilterDialogOpen: PropTypes.func.isRequired,
};

export default BondArchivesToolbar;
